import { render } from "./SchedulePostDialog.vue?vue&type=template&id=584f7f13&scoped=true"
import script from "./SchedulePostDialog.vue?vue&type=script&lang=js"
export * from "./SchedulePostDialog.vue?vue&type=script&lang=js"

import "./SchedulePostDialog.vue?vue&type=style&index=0&id=584f7f13&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584f7f13"]])

export default __exports__